import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import VehicleAdminReport from "./VehicleAdminReport";
import VehicleReportHub from "./VehicleReportHub";

const tabs = [
  { key: "ADMIN", label: "Admin Report", icon: "fa-table" },
  { key: "HUB",   label: "Hub Report",   icon: "fa-calendar" },
];

const contentVariants = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.2, ease: [0.4, 0, 0.2, 1] } },
  exit   : { opacity: 0, y: -6, transition: { duration: 0.13, ease: "easeIn" } },
};

const VehiclesReportTable = () => {
  const [stage, setStage] = useState<string>("ADMIN");

  return (
    <div className="efl-tab-page">
      {/* ── Tab bar ─────────────────────────────────────────── */}
      <div className="efl-tab-bar">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`efl-tab-btn${stage === tab.key ? " active" : ""}`}
            onClick={() => setStage(tab.key)}
          >
            <i className={`fa ${tab.icon} mr-1`} />
            {tab.label}

            {stage === tab.key && (
              <motion.div
                className="efl-tab-indicator"
                layoutId="vehicle-tab-indicator"
                transition={{ type: "spring", stiffness: 400, damping: 30 }}
              />
            )}
          </button>
        ))}
      </div>

      {/* ── Tab content with animation ──────────────────────── */}
      <AnimatePresence mode="wait">
        <motion.div
          key={stage}
          variants={contentVariants}
          initial="initial"
          animate="animate"
          exit="exit"
        >
          {stage === "ADMIN" && (
            <VehicleAdminReport stage={stage} setStage={setStage} />
          )}
          {stage === "HUB" && (
            <VehicleReportHub stage={stage} setStage={setStage} />
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default VehiclesReportTable;
